import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-col-sm-12 q-col-lg-3 q-p-0 promoted-product__container q-d-lg-none q-d-xl-block" }

import PromotedProduct from "./PromotedProduct.vue";
import PromotedProductHeader from './PromotedProductHeader.vue'

import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";



export default /*@__PURE__*/_defineComponent({
  __name: 'PromotedProductContainer',
  props: ['promotedProductHeader', 'promotedProduct'],
  setup(__props) {


const mobileViewStore = useMobileViewStore();
const {isMobileView} = storeToRefs(mobileViewStore)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isMobileView))
      ? (_openBlock(), _createBlock(PromotedProductHeader, {
          key: 0,
          "promoted-product-header": __props.promotedProductHeader
        }, null, 8, ["promoted-product-header"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(PromotedProduct, {
      "promoted-product": __props.promotedProduct,
      key: __props.promotedProduct.id
    }, null, 8, ["promoted-product"]))
  ]))
}
}

})